import { AfterViewInit, AfterViewChecked, Component, Input } from '@angular/core';
import {
  datePipe,
  getRandomColorWithOpacity,
  wrapLabel,
  yAxisformateValue,
} from '@piqet-angular/data';
import { Chart, ChartOptions } from 'chart.js';
import { Process } from '../iso-report/iso-report.component';
import { bottom } from '@popperjs/core';
import { reportTitals } from 'libs/shared/src/lib/reportConstant';
import {
  conclusion,
  executiveSummary,
  goalAndScope,
  impactAssessmentResult,
  interpretation,
  introduction,
  inventory,
} from 'libs/shared/src/lib/reportShowHideName';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { commonEnum } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-custom-project-report',
  templateUrl: './custom-project-report.component.html',
  styleUrls: ['./custom-project-report.component.scss'],
})
export class CustomProjectReportComponent implements AfterViewInit {
  @Input() reportData: any;
  reviewColorList: any = [];
  isLoadAllData: boolean = false;
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  staticDate = new Date();
  reportResource = reportTitals;
  isTocVisible = false;
  reportIntroduction = introduction;
  reportExecutiveSummary = executiveSummary;
  reportGoalAndScope = goalAndScope;
  reportInventory = inventory;
  reportImpactAssessmentResult = impactAssessmentResult;
  reportInterpretation = interpretation;
  reportConclusion = conclusion;
  commonData: any;
  introductionData: any = [];
  goalAndScopeData: any = [];
  inventory: any = [];
  showHideSection: any = [];
  indicatorList: any = [];
  dataQualityAssessmentList: any = [];
  includeProcessHideShow: any;
  spiderChartItemsData: any;
  imagelist: any;
  indicatornamelist: any;
  indicatorunitnamelist: any;
  spiderChartData: any = [];
  spiderChartLabels: string[] = [];
  chartImage: any;
  componentItemsArray: any;
  componentItemsArrayISOreport: any;
  componentItems: any;
  componentItemsBArChart: any;
  lifeCycleImpactTableId: any;
  parentArr: any;
  parentArrIso: any;
  childCount: any;
  includeProcessHideShowDetailModel: any;

  ratings = [
    { color: 'rgb(255, 46, 52)', title: 'Poor', value: 4 },
    { color: 'rgb(255, 155, 20)', title: 'Fair', value: 3 },
    { color: 'rgb(20, 232, 5)', title: 'Good', value: 2 },
    { color: 'rgb(5, 232, 250)', title: 'Very good', value: 1 },
  ];

  sectionList: any;
  tableIndexList: any = [];
  figureIndexList: any = [];
  chartOpacity: any = { value: commonEnum.opacity };
  indicatorsName: string = '';
  generatedChartType: string = 'column';
  equevalancyTableId!: number;
  climatemateImpactFigureId!: number;
  sensitivityAnalysis: any = [];
  scenarioImages: any = [];
  qualityTableId!: number;
  categoryDefTableId!: number;
  wasterMaterialTableId!: number;
  allcationFactorTableId!: number;
  materialList: any;
  isIncludedProcessExist: boolean = false;
  isExcludedProcessExist: boolean = false;
  isIncludedPackagingExist: boolean = false;
  isExcludedPackagingExist: boolean = false;
  reportAccessData: any;
  projectDetails: any;
  spiderChartItems: any;

  execulativeSummaryFlag: boolean = false;
  introductionFlag: boolean = false;
  goalAndScopeFlag: boolean = false;
  inventoryFlag: boolean = false;
  impactAssessmentResultsFlag: boolean = false;
  interpretationFlag: boolean = false;
  conclusionFlag: boolean = false;
  constructor(private reportService: ReportsService) {}

  ngOnInit() {
    this.commonData = this.reportData?.common;
    this.projectDetails = this.reportData?.projectDetails;
    this.spiderChartItems = this.reportData?.spiderChartItems;
    this.scenarioImages = this.reportData?.common?.scenarioImages;
    this.introductionData = this.reportData?.introduction;
    this.goalAndScopeData = this.reportData?.goalAndScope;
    this.inventory = this.reportData?.inventory;
    this.includeProcessHideShowDetailModel =
      this.reportData?.goalAndScope?.includeProcessHideShowDetailModel;
    this.isIncludedProcessExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => x.selected && x.flag
    );
    this.isExcludedProcessExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => !x.selected && x.flag
    );
    this.isIncludedPackagingExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => x.selected && !x.flag
    );
    this.isExcludedPackagingExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => !x.selected && !x.flag
    );
    this.sensitivityAnalysis = this.reportData?.sensitivityAnalysis;
    this.includeProcessHideShow = this.reportData?.goalAndScope?.includeProcessHideShowViewModel;
    this.showHideSection = this.reportData?.showHideSection;
    this.spiderChartItemsData = this.reportData?.spiderChartItems;
    this.chartOpacity = { value: this.spiderChartItemsData?.opacity };

    this.dataQualityAssessmentList = this.reportData.interpretation?.dataQualityAssessmentList;
    this.materialList =
      this.reportData.interpretation?.dataQualityAssessmentList?.dataQualityAssessmentData;
    this.reviewColorList = this.reportData.interpretation?.dataQualityAssessmentList?.ratings;
    this.indicatorList = this.reportData?.goalAndScope?.indicatorList;
    this.imagelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]
      ?.indicatorImageNameTable
      ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorImageNameTable.split(';')
      : [];
    this.indicatornamelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators
      ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicators.split(';')
      : [];
    this.indicatorunitnamelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]
      ?.indicatorUnitName
      ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorUnitName.split(';')
      : [];

    // spider chart
    this.componentItemsArray = this.spiderChartItemsData?.scenarioList;

    // bar chart
    const componentItemsArrayISOreport = this.spiderChartItemsData?.scenarioList.map((x: any) => {
      return {
        ...x,
        impactValues: x.normalizedValue,
        name: x.scenarioname,
      };
    });
    this.componentItemsArrayISOreport = componentItemsArrayISOreport;
    this.indicatorsName = this.spiderChartItemsData?.indicatorName;
    // this.categorizeProcesses();
  }

  getReportExecutiveSummaryAccess(name: any) {
    if (!!this.reportAccessData) {
      const accessdData = this.reportAccessData.executiveSummary.find((data: any) => {
        return data.name == name;
      });
      if (!!accessdData) {
        return accessdData.isAccess;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async getReportData(
    isCustomReportSetting: any,
    reportGenerationTypeId: any,
    projectReportSettingId: any
  ) {
    const responce = await this.reportService
      .getOrganizationReportSetting(
        isCustomReportSetting,
        reportGenerationTypeId,
        projectReportSettingId
      )
      .toPromise();
    this.reportAccessData = responce.data;
    const introductionFlag = this.reportAccessData.introduction.filter(
      (item: any) =>
        (item.name === 'Critical review considerations' && item.isAccess) ||
        (item.name === 'Introduction (ISO 14044 Standards)' && item.isAccess)
    );
    this.introductionFlag = introductionFlag.length ? true : false;
    this.execulativeSummaryFlag = this.reportAccessData.executiveSummary.some(
      (item: any) => item.isAccess
    );
    this.goalAndScopeFlag = this.reportAccessData.goalAndScope.some((item: any) => item.isAccess);
    this.inventoryFlag = this.reportAccessData.inventory.some((item: any) => item.isAccess);
    this.impactAssessmentResultsFlag = this.reportAccessData.impactAssessmentResults.some(
      (item: any) => item.isAccess
    );
    this.interpretationFlag = this.reportAccessData.interpretation.some(
      (item: any) => item.isAccess
    );
    this.conclusionFlag = this.reportAccessData.conclusion.some((item: any) => item.isAccess);

    this.sectionList = [
      {
        index: 1,
        title: 'Introduction',
        id: 'introduction',
        flag: this.introductionFlag,
        dataKey: 'introduction',
        children: [
          {
            title: 'Critical review considerations',
            id: 'criticalReview',
            filter: this.reportIntroduction.criticalReviewConsiderations,
          },
        ],
      },
      {
        index: 1,
        title: 'Executive Summary',
        id: 'execulativeSummary',
        flag: this.execulativeSummaryFlag,
        dataKey: 'executiveSummary',
        children: [
          {
            title: 'Project details',
            id: 'projectSummary',
            filter: this.reportExecutiveSummary.projectSummary,
          },
          {
            title: 'Scenario comparison',
            id: 'scenarioComparison',
            filter: this.reportExecutiveSummary.spiderChartSummary,
          },
          {
            title: 'Results summary table',
            id: 'resultSummary',
            filter: this.reportExecutiveSummary.resultSummaryTable,
          },
          {
            title: 'Comparison to benchmark',
            id: 'comparisonBenchmarks',
            filter: this.reportExecutiveSummary.comparisonToBenchmark,
          },
          {
            title: 'Annualized results',
            id: 'annualized',
            filter: this.reportExecutiveSummary.annualizedResult,
          },
        ],
      },
      {
        index: 1,
        title: 'Goal and Scope',
        id: 'goalAndScope',
        flag: this.goalAndScopeFlag,
        dataKey: 'goalAndScope',
        children: [
          { title: 'Goal', id: 'goal', filter: this.reportGoalAndScope.goalAndScope },
          {
            title: 'Functional unit',
            id: 'functionalUnit',
            filter: this.reportGoalAndScope.functionalUnit,
          },
          {
            title: 'System boundaries',
            id: 'systemBoundaries',
            filter: this.reportGoalAndScope.systemBoundary,
          },
          {
            title: 'Included processes',
            id: 'includedProcess',
            filter: this.reportGoalAndScope.includedProcesses,
          },
          {
            title: 'Excluded processes',
            id: 'excludedProcess',
            filter: this.reportGoalAndScope.excludedProcesses,
          },
          {
            title: 'Multi-functionality',
            id: 'multiFunctionality',
            filter: this.reportGoalAndScope.multiFunctionality,
          },
          {
            title: 'Impact assessment categories',
            id: 'impactAssessmentCategory',
            filter: this.reportGoalAndScope.impactCategories,
          },
          {
            title: 'Data quality requirements',
            id: 'dataQualityAssessment',
            filter: this.reportGoalAndScope.dataQualityFramework,
          },
        ],
      },
      {
        index: 1,
        title: 'Inventory',
        id: 'inventoryParent',
        flag: this.inventoryFlag,
        dataKey: 'inventory',
        children: [
          {
            title: 'Inventory analysis',
            id: 'foregroundData',
            filter: this.reportInventory.inventoryAnalysis,
          },
          {
            title: 'Foreground data',
            id: 'foregroundData',
            filter: this.reportInventory.foregroundDataEnter,
          },
          {
            title: 'Other assumptions',
            id: 'otherAssumption',
            filter: this.reportInventory.otherAssumptions,
          },
          {
            title: 'Background data',
            id: 'backgroundData',
            filter: this.reportInventory.backGroundData,
          },
        ],
      },
      {
        index: 1,
        title: 'Impact assessment results',
        id: 'impactAssessmentResults',
        flag: this.impactAssessmentResultsFlag,
        dataKey: 'impactAssessmentResults',
        children: [
          {
            title: ' Results summary characterization',
            id: 'resultSummaryCharacterization',
            filter: this.reportImpactAssessmentResult.resultsCharacterization,
          },
          {
            title: 'Results summary normalized',
            id: 'resultSummaryNormalized',
            filter: this.reportImpactAssessmentResult.resultSummaryNormalized,
          },
          {
            title: 'Results annualized',
            id: 'resultAnnualized',
            filter: this.reportImpactAssessmentResult.resultAnnulizedEquivalence,
          },
        ],
      },
      {
        index: 1,
        title: ' Interpretation',
        id: 'interpretation',
        flag: this.interpretationFlag,
        dataKey: 'interpretation',
        children: [
          {
            title: 'Contribution analysis',
            id: 'contributionAnalysis',
            filter: this.reportInterpretation.contributionalAnalysis,
          },
          {
            title: 'Contribution analysis by life cycle stage',
            id: 'contributionAnalysisByStage',
            filter: this.reportInterpretation.contributionalAnalysisByStage,
          },
          {
            title: 'Contribution analysis by component',
            id: 'contributionAnalysisByComponent',
            filter: this.reportInterpretation.contributionalAnalysisByComponent,
          },
          {
            title: 'Contribution analysis by packaging level',
            id: 'contributionAnalysisByPackaging',
            filter: this.reportInterpretation.contributionalAnalysisByPackaging,
          },
          {
            title: 'Sensitivity analysis',
            id: 'sensitivityAnalysis',
            filter: this.reportInterpretation.sensitivityAssessment,
          },
          {
            title: ' Interpretation',
            id: 'pInterpretation',
            filter: this.reportInterpretation.interpretationSummary,
          },
          {
            title: ' Data quality assessment',
            id: 'dataQualityAssessment5',
            filter: this.reportInterpretation.dataQualityAssessment,
          },
        ],
      },
      {
        index: 1,
        title: 'Conclusion',
        id: 'conclusion',
        flag: this.conclusionFlag,
        dataKey: 'conclusion',
        children: [
          {
            title: ' Limitations of the study',
            id: 'limitationOfTheStudy',
            filter: this.reportConclusion.limitationOfStudy,
          },
          {
            title: 'Recommendations and conclusions',
            id: 'recommendationsAndConclusions',
            filter: this.reportConclusion.recommendations,
          },
        ],
      },
    ];
  }
  toggleToc(eve: any) {
    this.isTocVisible = !this.isTocVisible;
  }
  getReportIntroduction(name: any) {
    return (
      !!this.reportAccessData?.introduction?.find((data: any) => data.name === name)?.isAccess ||
      false
    );
  }

  async ngAfterViewInit(): Promise<void> {
    await this.getReportData(
      this.reportData.flag,
      this.reportData.isCheckeportListByFormateById,
      this.reportData.isCheckeportListByTypeById
    );
    setTimeout(() => {
      let elements = document.querySelectorAll('.uniqTableSeq');
      let elementsFigure = document.querySelectorAll('.uniqFigureSeq');
      let chartDesign = document.querySelectorAll('.chartDesign ');
      let tableParent = document.querySelectorAll('.tableParent ');
      let parentTitle = document.querySelectorAll('.parentTitle ');
      let count = 1;
      let countFigure = 1;
      let parentCount = 1;
      let tableParentCount = 1;

      for (let i = 0; i < tableParent?.length; i++) {
        let getTableParent = tableParent[i].querySelectorAll('.tableParentNumber');
        let getTableChild = tableParent[i].querySelectorAll('.tableChildNumber');
        getTableParent.forEach((element: any) => {
          let innerHTMLParent = element.innerHTML;
          let updatedHTML = innerHTMLParent.replace(/#1Parent/g, tableParentCount.toString());
          element.innerHTML = updatedHTML;
        });
        if (getTableParent?.length > 0) {
          getTableChild.forEach((element: any, index: number) => {
            let innerHTMLChild = element.innerHTML;
            const childCount = `${tableParentCount}.${index + 1}`;
            let updatedHTML = innerHTMLChild.replace(/#1Child/g, childCount.toString());
            element.innerHTML = updatedHTML;
          });
        }
        tableParentCount++;
      }

      for (let i = 0; i < parentTitle?.length; i++) {
        let getParent = parentTitle[i].querySelectorAll('.parentNumber');
        let getChild = parentTitle[i].querySelectorAll('.childNumber');
        getParent.forEach((element: any) => {
          let innerHTMLParent = element.innerHTML;
          let updatedHTML = innerHTMLParent.replace(/#1Parent/g, parentCount.toString());
          element.innerHTML = updatedHTML;
        });
        if (getParent?.length > 0) {
          let customIndex = 0;
          getChild.forEach((element: any) => {
            const subChild = element.querySelectorAll('.subchildNumber');
            if (subChild?.length > 0) {
              subChild.forEach((element: any, subIndex: any) => {
                let innerHTMLSubChild = element.innerHTML;
                const sunChildCount = `${this.childCount}.${subIndex + 1}`;
                let updatedHTML = innerHTMLSubChild.replace(
                  /#1SubChild/g,
                  sunChildCount.toString()
                );
                element.innerHTML = updatedHTML;
              });
            }

            let innerHTMLChild = element.innerHTML;
            if (!innerHTMLChild.includes('div')) {
              this.childCount = `${parentCount}.${customIndex + 1}`;
              let updatedHTML = innerHTMLChild.replace(/#1Child/g, this.childCount.toString());
              element.innerHTML = updatedHTML;
              customIndex++; // Increment custom index only when condition is true
            } else {
              this.childCount = `${parentCount}.${customIndex + 1}`;
              let updatedHTML = innerHTMLChild.replace(/#1Child/g, this.childCount.toString());
              element.innerHTML = updatedHTML;
            }
          });
        }
        parentCount++;
      }

      for (let i = 0; i < elementsFigure?.length; i++) {
        let innerHTML = elementsFigure[i].innerHTML;
        let updatedHTML = innerHTML.replace(/#1/g, countFigure.toString());
        elementsFigure[i].innerHTML = updatedHTML;
        if (
          elementsFigure[i].innerHTML.includes(
            ' Climate change comparison contribution by life cycle stage - per package'
          )
        ) {
          this.climatemateImpactFigureId = countFigure;
        }
        if (!innerHTML.includes('is shown')) {
          // if (!!chartDesign[i]) {
          chartDesign[i]['id'] = countFigure - 1 + 'figureIndex';
          this.figureIndexList.push(elementsFigure[i].innerHTML);
          countFigure++;
          // }
        }
      }
      for (let i = 0; i < elements?.length; i++) {
        elements[i].id = i + 'tableIndex';
        let innerHTML = elements[i].innerHTML;
        if (elements[i].innerHTML.includes('Equivalence values')) {
          this.equevalancyTableId = count;
        }
        if (elements[i].innerHTML == 'Table #1: Data quality assessment') {
          this.qualityTableId = count;
        }
        if (
          elements[i].innerHTML == 'Table #1: Materials used in study and corresponding A Factors'
        ) {
          this.wasterMaterialTableId = count;
        }
        if (elements[i].innerHTML == ' Table #1: Categories definition ') {
          this.categoryDefTableId = count;
        }
        if (elements[i].innerHTML == 'Table #1: Life cycle impacts - per package') {
          this.lifeCycleImpactTableId = count;
        }
        if (elements[i].innerHTML == 'Table #1: Recycling allocation factors') {
          this.allcationFactorTableId = count;
        }
        let updatedHTML = innerHTML.replace(/#1/g, count.toString());
        elements[i].innerHTML = updatedHTML;
        this.tableIndexList.push(elements[i].innerHTML);
        count++;
      }
      this.isLoadAllData = true;
    }, 100);
  }

  getRange(x: number): number[] {
    return Array.from({ length: x }, (_, index) => index);
  }

  getFormateDate(date: any) {
    return datePipe(date);
  }
  getMulti(x: any, y: any) {
    const cleanedImpact = parseFloat(x.replace(/,/g, ''));
    const value = cleanedImpact * y;
    return value.toString();
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  formatText(text: string): string {
    if (!text) return '';
    let formattedText = text.replace(/(?<!>)\n(?!\s*<)/g, '<br>');
    formattedText = formattedText.replace(/<\s*h[1-6]\b[^>]*>(.*?)<\s*\/\s*h[1-6]>/gi, '<p>$1</p>');
    return formattedText;
  }
}
